import {Box, Button, createStyles, Text} from '@mantine/core';
import React from 'react';

import {ACTION_CATEGORY} from 'analytics/AnalyticsTypes';
import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import preferences from 'Preferences';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import * as SidepanelActions from '../SidepanelActions';
import HomepageBanner from './HomepageBanner';
import {HomepagePreferences} from './HomepageConstants';
import {trackHomepageEvent} from './HomepageUtils';

const useStyles = createStyles((theme) => ({
  text: {
    fontSize: theme.fontSizes.md,
  },
  title: {
    fontWeight: theme.other.fontWeights.semibold,
  },
  returnLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  xsMarginRight: {
    marginRight: theme.spacing.xs,
  },
  feedbackButton: {
    // it's a link, so this is a reset
    '&:hover': {
      color: 'unset',
      textDecoration: 'unset',
    },
  },
}));

export default function HomepagePreviewBanner(): JSX.Element {
  const {classes} = useStyles();

  const {navShowHomepageUserOptOut} = useRolloutFlags();

  const handleReturnToLegacyHomepage = (): void => {
    trackHomepageEvent('opted_out', ACTION_CATEGORY.WRITE);
    SidepanelActions.collapse();
    preferences.set(HomepagePreferences.SHOW_NEW_HOMEPAGE, false);
  };

  return (
    <HomepageBanner
      color="yellow"
      rightSection={
        <Button
          // eslint-disable-next-line no-restricted-syntax -- no custom variant matches the design, yet
          variant="default"
          color="gray"
          component="a"
          radius="md"
          href="https://forms.gle/8kcjGfRn227coUBF7"
          leftIcon={<BenchlingIcon icon="message" className={classes.xsMarginRight} />}
          rel="noopener noreferrer"
          size="md"
          target="_blank"
          className={classes.feedbackButton}
        >
          Share feedback
        </Button>
      }
    >
      <Box className={classes.text}>
        <Text className={classes.title}>Welcome to your new homepage!</Text>
        {navShowHomepageUserOptOut && (
          <Text>
            The new homepage is in limited availability.{' '}
            <Text
              span={true}
              className={classes.returnLink}
              {...getActionButtonRoleProps({onPress: handleReturnToLegacyHomepage})}
            >
              Switch back to the legacy homepage
            </Text>{' '}
            anytime during this period.
          </Text>
        )}
      </Box>
    </HomepageBanner>
  );
}
